import React, { useEffect, useRef, useState } from 'react';

import { TextField } from '@mui/material';

import Styles from '../lib/Styles';
import classes from './SelectBoxedField.module.scss';

export default function SelectZipCodes(props: any) {
  const { selectedZipCodes, setSelectedZipCodes, onChangeZipCodes, zipCodesError, setZipCodesError, readOnly } = props;
  let initialValue = useRef(props.initialValue);
  const cx = new Styles(classes).cx;

  const [duplicateZipCodes, setDuplicateZipCodes] = useState<boolean>(false);

  useEffect(() => {
    if (initialValue.current) {
      setSelectedZipCodes(initialValue.current);
      initialValue.current = undefined;
    }
  }, [setSelectedZipCodes])

  // Only numeric key input will trigger this handleChange method.
  // Don't allow more than 5 digits to be entered.
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDuplicateZipCodes(false);

    let value = event.target.value;
    if (value.length === 0) {
      setZipCodesError(false);
    } else {
      // Only allow text with numbers and spaces to be pasted.  The handleKeyPress() will only allow numbers
      // and spaces to be entered.  But if the user Pastes content - we then catch that here, to allow only
      // numbers or spaces.  No error is displayed.
      if (!(/^(\d| )+$/.test(value))) {
        return;
      }
    }

    if (areThereDuplicateZipCodes(value)) {
      setDuplicateZipCodes(true);
      setZipCodesError(true);
    } else if (areZipCodesAllValid(value)) {
      setZipCodesError(false);
    }

    console.log("Duplicates? " + duplicateZipCodes.toString());

    setSelectedZipCodes(value);
    onChangeZipCodes();
  };

  const areThereDuplicateZipCodes = (value: string) => {
    let zipArray: Array<string> = value.split(' ').map((zip: string) => zip.trim());
    let duplicates = false;
    const setZips: Set<string> = new Set();
    zipArray.forEach((zip: string, index: number) => {
      if (setZips.has(zip)) {
        setDuplicateZipCodes(true);
        duplicates = true;
      } else {
        setZips.add(zip);
      }
    });
    return duplicates;
  };

  // Only allow numeric and space keys to be processed by onChange handler.
  // Prevent entry of numbers with more than 5 digits.
  // PASTE can still add in more digits, but seems a bit overkill to add in guard code for that right now.
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if ("0123456789 ".indexOf(event.key) < 0) {
      event.preventDefault();
    } else {
      let eventTarget: any = event?.nativeEvent?.target;
      let startPos = eventTarget?.selectionStart;
      let endPos = eventTarget?.selectionEnd;
      let value = eventTarget?.value;

      if (startPos === endPos) {
        if ((event.key === " ") && (value[endPos - 1] === " ")) {
          event.preventDefault();
        } else if ("0123456789".indexOf(event.key) >= 0) {
          let lenOfNumber = lenOfCurrentNumber(value, startPos);
          if (lenOfNumber === 5) {
            event.preventDefault();
          }
        }
      }
    }
  };

  const lenOfCurrentNumber = (value: string, pos: number): number => {
    let backIndex = pos - 1;
    let forwardIndex = pos;
    while (backIndex >= 0 && "0123456789".indexOf(value[backIndex]) >= 0) {
      backIndex--;
    }
    while (forwardIndex <= value.length && "0123456789".indexOf(value[forwardIndex]) >= 0) {
      forwardIndex++;
    }
    return forwardIndex - backIndex - 1;
  }

  // value is a string containing zero or more space delimited 5-digit zip codes.
  // Tolerate multiple spaces between zip codes.
  const areZipCodesAllValid = (value: string): boolean => {
    let result: boolean = true;
    if (value) {
      let values = value.trim().split(' ');
      for (let i = 0; i < values.length; i++) {
        let val = values[i].trim();
        if (val.length !== 0 && val.length !== 5) {
          result = false;
        }
      }
    }
    return result;
  }

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    let value = event.target.value;
    const dupErrors = areThereDuplicateZipCodes(value);
    setDuplicateZipCodes(dupErrors);
    let err: boolean = !!value && (!areZipCodesAllValid(value) || dupErrors);
    console.log(dupErrors);
    setZipCodesError(err);
  }

  return (
    <div className={cx('root')}>
      <form className={cx('form')}noValidate autoComplete="off">
        <TextField className={cx('textfield')}
        disabled={readOnly}
        error={zipCodesError}
        helperText={!zipCodesError ? '' : (duplicateZipCodes ? 'Zip codes may only be listed once' : 'All zip codes must be 5 digits long')}
        id="outlined-basic"
        label="Zip Codes"
        placeholder="Enter one or more 5-digit zip codes, separated by a space."
        type="text"
        variant="outlined"
        value={selectedZipCodes || ''}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        onBlur={handleBlur}
      />
    </form>
    </div>
  );
}